import { css, cx } from '@emotion/css'
import React from 'react'
import { CsCloudIcon } from '../../../legacy-design-system/icons/cloud-icon'
import { WithTooltip } from '../../../design-system'
import { FormattedMessage } from 'react-intl'

export const cssTransitionTime = 350

const cssExportContainer = css`
  z-index: 1; /* This is so that row/column modules don't hide this anchored button */
  position: absolute;
  top: 28px;
  right: 28px;
`

const cssExportButton = css`
  cursor: pointer;
  transition: opacity ${cssTransitionTime}ms ease-in-out;
  -moz-transition: opacity ${cssTransitionTime}ms ease-in-out;
  -webkit-transition: opacity ${cssTransitionTime}ms ease-in-out;
`

const cssExportButtonVisible = css`
  opacity: 1;
`

const cssExportButtonHidden = css`
  opacity: 0;
`

export function VrApiExportHover({
  children,
  className,
  onExportClick,
  exportButtonE2eTestId
}: {
  readonly children: React.ReactNode
  readonly onExportClick: () => void
  readonly className?: string
  readonly exportButtonE2eTestId?: string
}) {
  return (
    <div className={className}>
      <VrApiExportButton
        onClick={onExportClick}
        visible={true}
        e2eTestId={exportButtonE2eTestId}
      />
      {children}
    </div>
  )
}

export function VrApiExportButton({
  onClick,
  visible,
  e2eTestId
}: {
  readonly visible: boolean
  readonly onClick: () => void
  readonly e2eTestId?: string
}) {
  const cssExportVisibility = visible
    ? cssExportButtonVisible
    : cssExportButtonHidden

  return (
    <div className={cssExportContainer}>
      <WithTooltip
        placement="bottom"
        tiny={true}
        renderTooltipContent={() => <FormattedMessage id="title_api" />}
        children={() => (
          <CsCloudIcon
            size={30}
            className={cx(cssExportButton, cssExportVisibility)}
            onClick={onClick}
            e2eTestId={e2eTestId}
          />
        )}
      />
    </div>
  )
}
